const RoadSmall = ({ ...props }) => {
  return (
    <svg
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6778_5012)">
        <g clipPath="url(#clip1_6778_5012)">
          <path d="M0 21.8438H20.625" stroke="white" strokeMiterlimit="10" />
          <path d="M0 1.21875H20.625" stroke="white" strokeMiterlimit="10" />
          <path d="M0 11.5312H4.125" stroke="white" strokeMiterlimit="10" />
          <path
            d="M7.21875 11.5312H13.4062"
            stroke="white"
            strokeMiterlimit="10"
          />
          <path d="M16.5 11.5312H20.625" stroke="white" strokeMiterlimit="10" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6778_5012">
          <rect
            width="20.625"
            height="22"
            fill="white"
            transform="translate(0 0.53125)"
          />
        </clipPath>
        <clipPath id="clip1_6778_5012">
          <rect
            width="20.625"
            height="22"
            fill="white"
            transform="translate(0 0.53125)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RoadSmall
